import CommunityAddress from './CommunityAddress';

export default CommunityAddress;
